module.exports = __webpack_public_path__ + "static/media/project-wikipedia.814f9851.png";